<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-cps-app-select @changeCpsApp="changeCpsApp" :checked="false" />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-select
        v-model="tableParams.orderType"
        filterable
        placeholder="占比类型"
      >
        <el-option
          v-for="item in orderTypeList"
          :key="item.orderType"
          :label="item.title"
          :value="item.orderType"
        />
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          sortable
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <template v-if="v.field === 'mediaTypeName'">
              <span>
                {{
                  scope.row[v.field] == "Live"
                    ? "直播间"
                    : scope.row[v.field] == "ProductDetail"
                    ? "商品详情"
                    : "-"
                }}
              </span>
            </template>
            <template v-else-if="v.field === 'flowPoint'">
              <span>
                {{
                  scope.row[v.field] == "PAY_SUCC"
                    ? "支付完成"
                    : scope.row[v.field] == "REFUND"
                    ? "退款"
                    : scope.row[v.field] == "SETTLE"
                    ? "结算"
                    : scope.row[v.field] == "CONFIRM"
                    ? "确认收货"
                    : "-"
                }}
              </span>
            </template>
            <template v-else-if="v.field === 'afterSalesStatus'">
              <span>
                {{ scope.row[v.field] == "2" ? "产生退款" : "-" }}
              </span>
            </template>
            <template v-else-if="v.field === 'adsAttribution'">
              <span>
                {{
                  scope.row[v.field] == "intersect"
                    ? "跨播"
                    : scope.row[v.field] == "directIn"
                    ? "直推"
                    : "-"
                }}
              </span>
            </template>
            <template v-else-if="v.field === 'productImg'">
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                ref="popover"
              >
                <template #reference>
                  <el-image :src="scope.row[v.field]" error="-" width="100">
                    <template #error>
                      <div class="image-slot">
                        <span>-</span>
                      </div>
                    </template>
                  </el-image>
                </template>
                <img :src="scope.row[v.field]" style="height: 250px" alt="" />
              </el-popover>
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import initTableMixin from "@/mixins/initTable";
import BaseDatePicker from "@/components/BaseDatePicker";
import { downExcelMixin } from "@/mixins/downExcel";
import SearchCpsAppSelect from "@/components/SearchCpsAppSelect";

export default {
  components: {
    BaseDatePicker,
    SearchCpsAppSelect,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      checkColumns: [
        { field: "orderId", title: "订单ID" },
        { field: "appId", title: "应用ID" },
        { field: "productId", title: "商品ID" },
        { field: "productName", title: "商品名称" },
        {
          field: "authorAccount",
          title: "直播间达人昵称",
        },
        { field: "adsAttribution", title: "结算方式" },
        { field: "productImg", title: "商品图片" },
        { field: "totalPayAmount", title: "总金额付款(分)" },
        { field: "paySuccessTime", title: "支付成功时间" },
        { field: "refundTime", title: "退款时间" },
        { field: "payGoodsAmount", title: "预估结算金额(分)" },
        { field: "estimatedCommission", title: "预估佣金收入(分)" },
        { field: "splitRate", title: "推广费率(万分之一)" },
        { field: "afterSalesStatus", title: "售后状态" },
        { field: "flowPoint", title: "状态" },
        { field: "settleTime", title: "结算时间" },
        { field: "confirmTime", title: "确认收货时间" },
        { field: "updateTime", title: "订单状态更新时间" },
        { field: "estimatedTechServiceFee", title: "预估技术服务费" },
        {
          field: "externalInfo",
          title: "开发者在转链时自己上传的external_info",
        },
        { field: "mediaTypeName", title: "分销类型名称" },
      ],
      orderTypeList: [
        { orderType: 1, title: "商品分销订单" },
        { orderType: 2, title: "直播间分销订单" },
        { orderType: 3, title: "活动类型订单" },
      ],
      tableParams: {
        pageSize: 10,
        pageNum: 1,
      },
      tableData: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/order/search";
      return true;
    },
    afterInit(res) {
      this.tableData = res.data.records;
      console.log(this.tableData);
    },
    toQuery() {
      this.init();
    },
    changeCpsApp(val) {
      this.tableParams.appId = val.appId;
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime.replace(
        /^(\d{4})(\d{2})(\d{2})$/,
        "$1-$2-$3"
      );
      this.tableParams.endTime = date.endTime.replace(
        /^(\d{4})(\d{2})(\d{2})$/,
        "$1-$2-$3"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 30px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.search-row {
  & > .el-select,
  & > .el-input {
    margin-right: 30px;
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}
</style>
